import React from 'react';
import { isHTHCompany } from '../helpers/utils';

const HTH_CONFIGURE_URL = 'https://configure.thingscloud.it?newUI=true&cl=hth&fav=hth';
const STEIEL_CONFIGURE_URL = 'https://configure.thingscloud.it?newUI=true&cl=steiel&fav=steiel';

const Configure: React.FC = () => {
  const configureUrl = isHTHCompany() ? HTH_CONFIGURE_URL : STEIEL_CONFIGURE_URL;
  return (
    <iframe
      src={configureUrl}
      title='Thingscloud Configure'
      width='100%'
      height='100%'
      style={{
        border: 'none',
        display: 'block',
        position: 'fixed',
        inset: 0,
        width: '100vw',
        height: '100vh',
      }}
      allow='bluetooth; clipboard-read; clipboard-write'
    />
  );
};

export default Configure;
